import { Component, Input } from '@angular/core';
import { map } from 'rxjs/operators';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Subscription } from 'rxjs';
import { TickerTableDataSource } from '../main-table-content-v2/TickerTableDataSource';
import { MaintainTabDTO } from '../../../../../system/system-dtos';
import { BlastV2Service } from '../../service/blast-v2.service';

@Component({
  selector: 'app-main-table-v2-tabs',
  templateUrl: './main-table-v2-tabs.component.html',
  styleUrls: ['./main-table-v2-tabs.component.scss'],
  standalone: false,
})
export class MainTableV2TabsComponent {
  _dataTable: TickerTableDataSource;

  tabsCount: Map<string, number> = new Map<string, number>();

  private subscription: Subscription;

  get dataTable(): TickerTableDataSource {
    return this._dataTable;
  }

  @Input() set dataTable(_dataTable: TickerTableDataSource) {
    this._dataTable = _dataTable;
    this._dataTable?.changeSubject.subscribe((_) => {
      if (this.subscription && !this.subscription.closed) {
        this.subscription.unsubscribe();
      }
      this.subscription = this.blastV2Service
        .getCollectionObservable(`${this._dataTable.tableConfig.code}ticker`)
        .pipe(map((d) => d || []))
        .subscribe((d: any[]) => this.fillCountMap(d));
    });
  }

  private fillCountMap(entries: any[]) {
    this.dataTable.tableConfig.tabs.map((tab: MaintainTabDTO) => {
      const entriesCount = entries.filter((entry) => {
        if (tab?.initialConditions?.length > 0) {
          const { initialConditions } = tab;
          return initialConditions.filter((c) => entry.data[c.field] === c.value).length === initialConditions.length;
        }
        return true;
      }).length;

      this.tabsCount.set(tab.tableView.code, entriesCount);
    });
  }

  constructor(private blastV2Service: BlastV2Service) {}

  onTabChange($event: MatTabChangeEvent) {
    this.dataTable.tabSelected = this.dataTable?.tableConfig?.tabs[$event.index];
  }
}
